import { isEmptyObject } from './isEmptyObject'

export const logger = (key: string, event: unknown, color: string = '#03c6fc') => {
  const message = `%c${key}`
  const decoration = `font-weight: bold; color: ${color};`

  if (!isEmptyObject(event)) {
    console.log(`${message}:\n`, decoration, event)
  } else {
    console.log(message, decoration)
  }
}
